'use client';

import { usePathname } from 'next/navigation';
import { getCountryLanguageByLocale, getLocaleByPathname } from '../server';
export default function useGetCountryLanguage() {
  var pathname = usePathname();
  var locale = getLocaleByPathname(pathname);
  return getCountryLanguageByLocale(locale);
}